import useQuery from '../../hooks/useQuery';

export default function useDriveQuery() {
  const query = useQuery();
  const empresaId = query.has('empresaId') ? parseInt(query.get('empresaId')) : undefined;
  return {empresaId};
}
